export const MAX_ATTACHMENTS = 10;
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const MAX_TOTAL_SIZE = 25 * 1024 * 1024;
export const ALLOWED_TYPES = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
    'image/svg+xml',
    'image/bmp',
    'application/pdf',
    'text/plain',
    'text/csv',
    'text/markdown',
    'application/json',
    'application/zip',
];
export const ALLOWED_EXTENSIONS = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.svg',
    '.bmp',
    '.pdf',
    '.txt',
    '.csv',
    '.md',
    '.json',
    '.zip',
];
export function isAllowedMimeType(mimeType) {
    return ALLOWED_TYPES.includes(mimeType);
}
export function isAllowedExtension(extension) {
    return ALLOWED_EXTENSIONS.includes(extension.toLowerCase());
}
export function formatBytes(bytes) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}
//# sourceMappingURL=constants.js.map